import React, { Component, memo } from 'react'
import './index.less'

// 仓库
import { inject, observer } from 'src/core/store'
// 工具
import { setDocumentTitle, setUidToken, isRtl } from 'src/helper/tool'
// 语言适配
import { getlang, setlang } from 'src/helper/getlang'
import langM from './lang.js'
// 金币格式化
import score from 'src/helper/score'
// 时间格式化
// 文本提示
//import Toast from '../../../component/Toast'
// 弹窗禁止滑动
//import forbidScroll from 'src/tools/forbidScroll'
// 滑动组件
// import { Swiper, SwiperSlide } from 'swiper/react'

/* import Swiper from 'swiper'
import 'swiper/swiper-bundle.min.css'
import SwiperCore, { Autoplay } from 'swiper/core' */

// 跳转用户、房间
// 弹窗组件
import ReminderBtn from 'src/component/RuleButton'
import debounce from 'lodash/debounce'
import CountDown from 'src/component/CountDown'

@inject('store')
@observer
export default class wheelGame extends Component {
  constructor(props) {
    super(props)
    
    this.mStore = this.props.store.register('app/monopoly')
  }

  state = {
    cdtime: 0,
    // 用户信息
    uInfo: {},

    lang:langM.en,
    language: 'en',

    // 排行上周本周
    weekStatus: 2,
    rankStatus: 1,
    rewardStatus: 1,

    ruleShow: false,
    rewardShow: false,

    sendRewardList: [],
    recRewardList: [],
    showRewardList: [],

    // 发送
    lsRankList: [],
    tsRankList: [],
    // 接收
    lrRankList: [],
    trRankList: [],
    rankList: [],

    lsMyRank: {},
    tsMyRank: {},
    lrMyRank: {},
    trMyRank: {},
    myRank: {},

    giftInfo: {}
  }

  async componentDidMount() {
    let res = await this.mStore.GetServerTime()
    console.log(res, '啊啊啊')
    let res1 = await this.mStore.getMonopolyGift()
    let sList = []
    let rList = []
    
    sList.push(res1.res.sender_reward1)
    sList.push(res1.res.sender_reward2)
    sList.push(res1.res.sender_reward3)
    rList.push(res1.res.receiver_reward1)
    rList.push(res1.res.receiver_reward2)
    rList.push(res1.res.receiver_reward3)
    this.setState({
      giftInfo: res1.res.gift_info,
      showRewardList: sList,
      sendRewardList: sList,
      recRewardList: rList
    })

    let tsList = await this.mStore.getMonopolyRank({
      type: 0,
      week: 0
    })
    let lsList = await this.mStore.getMonopolyRank({
      type: 0,
      week: 1
    })
    let trList = await this.mStore.getMonopolyRank({
      type: 1,
      week: 0
    })
    let lrList = await this.mStore.getMonopolyRank({
      type: 1,
      week: 1
    })
    console.log(tsList, 'tsList')

    this.setState({
      rankList: tsList.res.list,

      tsRankList: tsList.res.list,
      lsRankList: lsList.res.list,
      trRankList: trList.res.list,
      lrRankList: lrList.res.list,

      myRank: tsList.res.me,

      tsMyRank: tsList.res.me,
      lsMyRank: lsList.res.me,
      trMyRank: trList.res.me,
      lrMyRank: lrList.res.me,

      cdtime: res.weekendts
    })
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    console.log('language', language)
    if (language == 'ar') {
      setDocumentTitle('Ruby Monopoly')
    }else if ( language == 'tr') {
      setDocumentTitle("Yakut Kralı")
    } else{
      setDocumentTitle('Ruby Monopoly')
    }
    
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    this.setState({
      uid: uid
    })
  }

  onChangeRewardStatus(status) {
    this.setState({
      rewardStatus: status
    })
    if (status == 1) {
      console.log(1)
      this.setState({
        showRewardList: this.state.sendRewardList
      })
    }
    if (status == 2) {
      console.log(2)
      this.setState({
        showRewardList: this.state.recRewardList
      })
    }
  }
  onChangeWeekStatus(status) {
    this.setState({ weekStatus: status })

    if (status == 1 && this.state.rankStatus == 1) {
      this.setState({
        rankList: this.state.lsRankList,
        myRank: this.state.lsMyRank
      })
    }
    if (status == 1 && this.state.rankStatus == 2) {
      this.setState({
        rankList: this.state.lrRankList,
        myRank: this.state.lrMyRank
      })
    }
    if (status == 2 && this.state.rankStatus == 1) {
      this.setState({
        rankList: this.state.tsRankList,
        myRank: this.state.tsMyRank
      })
    }
    if (status == 2 && this.state.rankStatus == 2) {
      this.setState({
        rankList: this.state.trRankList,
        myRank: this.state.trMyRank
      })
    }
  }
  onChangeRankStatus(status) {
    this.setState({ rankStatus: status })
    if (this.state.weekStatus == 1 && status == 1) {
      this.setState({
        rankList: this.state.lsRankList,
        myRank: this.state.lsMyRank
      })
    }
    if (this.state.weekStatus == 1 && status == 2) {
      this.setState({
        rankList: this.state.lrRankList,
        myRank: this.state.lrMyRank
      })
    }
    if (this.state.weekStatus == 2 && status == 1) {
      this.setState({
        rankList: this.state.tsRankList,
        myRank: this.state.tsMyRank
      })
    }
    if (this.state.weekStatus == 2 && status == 2) {
      this.setState({
        rankList: this.state.trRankList,
        myRank: this.state.trMyRank
      })
    }
  }

  langHeaderBg() {
    switch (this.state.language) {
      case 'tr':
        return '/img/app/monopoly/banner_tr.png'
      case 'ar':
        return '/img/app/monopoly/banner_ar.png'
      default:
        return '/img/app/monopoly/banner_b.png'
    }
  }

  render() {
    let { language } = this.state
    return (
      <div className={`rule-monopoly-main-wrapper ${isRtl(language) && 'arlang'}`}>
        <div className="rule-monopoly-header" style={{ backgroundImage: `url(${this.langHeaderBg()})` }}>
          <img className="dm" src="/img/app/monopoly/diamonds_b.png" alt="" />
          <img className="star" src="/img/app/gashapon/star.gif" alt="" />
          <div className="countdown">
            {/* Countdown: 08 day 12 : 00 : 00 */}
            <CountDown
              language={language}
              lang={this.state.lang}
              // leftTimestamp={1696176000 - new Date().getTime() / 1000}
              leftTimestamp={this.state.cdtime || 0}
            />
          </div>
          <div
            className="rule"
            onClick={() => {
              this.setState({ ruleShow: true })
            }}
          >
            &nbsp;&nbsp;&nbsp;{this.state.lang.rule}
          </div>
          <div
            className="reward"
            onClick={() => {
              this.setState({ rewardShow: true })
            }}
          >
            &nbsp;&nbsp;&nbsp;{this.state.lang.reward}
          </div>
        </div>
        <div className="rule-monopoly-gift-part">
          <div className="rule-monopoly-gift">
            <div className="gift-title">{this.state.lang.ruby_gift}</div>
            <div className="gift-item">
              <img src={'/img/app/monopoly/diamonds_b.png'} alt="" />
            </div>
            <div className="gift-name">{language == 'tr'?"Pırlanta":this.state.giftInfo.name}</div>
          </div>
        </div>
        <div className="rule-monopoly-gift-nav-part">
          <div
            className={`nav-item ${this.state.weekStatus == 1 && 'nav-item-active'}`}
            onClick={() => this.onChangeWeekStatus(1)}
          >
            {this.state.lang.lw}
          </div>
          <div
            className={`nav-item ${this.state.weekStatus == 2 && 'nav-item-active'}`}
            onClick={() => this.onChangeWeekStatus(2)}
          >
            {this.state.lang.tw}
          </div>
        </div>
        {this.state.myRank.duid && this.state.myRank.duid != '' && this.state.myRank.score > 0 && (
          <div className="rule-monopoly-gift-myrank">
            <div className="rank">{this.state.myRank && this.state.myRank.rank}</div>
            <img className="avatar" src={this.state.myRank && this.state.myRank.avatarurl} alt="" />
            <div className="info">
              <div className="name">{this.state.myRank && this.state.myRank.nickname}</div>
              <div className="id">ID:{this.state.myRank && this.state.myRank.duid}</div>
            </div>
            <div className="gold">{score(this.state.myRank && this.state.myRank.score)}</div>
          </div>
        )}

        <div className="rule-monopoly-gift-rank-list">
          <div className="top">
            <div className="tab-main">
              <div
                className={`tab-item ${this.state.rankStatus == 1 && 'tab-item-acitve'}`}
                onClick={() => this.onChangeRankStatus(1)}
              >
                {this.state.lang.sender}
              </div>
              <div
                className={`tab-item ${this.state.rankStatus == 2 && 'tab-item-acitve'}`}
                onClick={() => this.onChangeRankStatus(2)}
              >
                {this.state.lang.recipient}
              </div>
            </div>
          </div>
          <div className="content">
            <div className="rank-main">
              <div className="top1">
                <div className="ava">
                  <img className="bor" src="/img/app/monopoly/t1.png" alt="" />
                  <img
                    className="head"
                    src={this.state.rankList && this.state.rankList[0] && this.state.rankList[0].avatarurl}
                    alt=""
                  />
                </div>
                <div className="name">
                  {this.state.rankList && this.state.rankList[0] && this.state.rankList[0].nickname}
                </div>
                <div className="id">
                  ID:{this.state.rankList && this.state.rankList[0] && this.state.rankList[0].duid}
                </div>
                <div className="name">
                  {score(this.state.rankList && this.state.rankList[0] && this.state.rankList[0].score)}
                </div>
              </div>
              <div className="top2">
                <div className="ava">
                  <img className="bor" src="/img/app/monopoly/t2.png" alt="" />
                  <img
                    className="head"
                    src={this.state.rankList && this.state.rankList[1] && this.state.rankList[1].avatarurl}
                    alt=""
                  />
                </div>
                <div className="name">
                  {this.state.rankList && this.state.rankList[1] && this.state.rankList[1].nickname}
                </div>
                <div className="id">
                  ID:{this.state.rankList && this.state.rankList[1] && this.state.rankList[1].duid}
                </div>
                <div className="name">
                  {score(this.state.rankList && this.state.rankList[1] && this.state.rankList[1].score)}
                </div>
              </div>
              <div className="top3">
                <div className="ava">
                  <img className="bor" src="/img/app/monopoly/t3.png" alt="" />
                  <img
                    className="head"
                    src={this.state.rankList && this.state.rankList[2] && this.state.rankList[2].avatarurl}
                    alt=""
                  />
                </div>
                <div className="name">
                  {this.state.rankList && this.state.rankList[2] && this.state.rankList[2].nickname}
                </div>
                <div className="id">
                  ID:{this.state.rankList && this.state.rankList[2] && this.state.rankList[2].duid}
                </div>
                <div className="name">
                  {score(this.state.rankList && this.state.rankList[2] && this.state.rankList[2].score)}
                </div>
              </div>
            </div>
            <div className="rank-list">
              {this.state.rankList &&
                this.state.rankList.map((i, index) => {
                  if (index > 2) {
                    return (
                      <div className="rank-item" key={index}>
                        <div className="rank">{index + 1}</div>
                        <img className="avatar" src={i.avatarurl} alt="" />
                        <div className="info">
                          <div className="name">{i.nickname}</div>
                          <div className="id">ID:{i.duid}</div>
                        </div>
                        <div className="gold">{score(i.score)}</div>
                      </div>
                    )
                  }
                })}
            </div>
            {this.state.rankList.length <= 3 && <div className="rank-empty">{this.state.lang.empty}</div>}
          </div>
          <div className="bottom"></div>
        </div>
        <div className={`rule-monopoly-gift-reward`}>
          <div className={`shadow`} style={{ display: `${this.state.rewardShow ? 'block' : 'none'}` }}></div>
          <div className={`reward-main ${this.state.rewardShow && 'reward-main-active'}`}>
            <div className="top">
              <div className="reward-top-title">{this.state.lang.reward}</div>
            </div>
            <div className="center">
              <div className="reward-nav">
                <div
                  className={`reward-nav-item ${this.state.rewardStatus == 1 && 'reward-nav-item-active'}`}
                  onClick={() => this.onChangeRewardStatus(1)}
                >
                  {this.state.lang.sender}
                </div>
                <div
                  className={`reward-nav-item ${this.state.rewardStatus == 2 && 'reward-nav-item-active'}`}
                  onClick={() => this.onChangeRewardStatus(2)}
                >
                  {this.state.lang.recipient}
                </div>
              </div>
              <div className="reward-content-main">
                {this.state.showRewardList.map((i, index) => {
                  return (
                    <div className="reward-main-item" key={index}>
                      <div className="reward-title">{language == 'tr'?"İlk":'No'}{index + 1}</div>
                      <div className="reward-items">
                        {i.map((item, idx) => {
                          return (
                            <div className="reward-item" key={idx}>
                              <div className="box">
                                <img src={item.giftIcon} alt="" />
                              </div>
                              {/* <div className="name">{item.giftName}</div> */}
                              <div className={`day`}>
                              {/* {item.giftName} */}
                                {this.state.language == 'ar'
                                  ? this.state.lang.days + ' ' + item.expire / 86400
                                  : item.expire / 86400 + ' ' + this.state.lang.days}{' '}
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="bottom"></div>
            <div
              className="close"
              onClick={() => {
                this.setState({ rewardShow: false })
              }}
            ></div>
          </div>
        </div>
        <div className={`rule-monopoly-gift-reward`}>
          <div className={`shadow`} style={{ display: `${this.state.ruleShow ? 'block' : 'none'}` }}></div>
          <div className={`reward-main ${this.state.ruleShow && 'reward-main-active'}`}>
            <div className="top">
              <div className="reward-top-title">{this.state.lang.rule}</div>
            </div>
            <div className="center">
              <div
                className="rule-content"
                dangerouslySetInnerHTML={{ __html: this.state.lang.ruleContent || '' }}
              ></div>
            </div>
            <div className="bottom"></div>
            <div
              className="close"
              onClick={() => {
                this.setState({ ruleShow: false })
              }}
            ></div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby-monopoly-main/index.js